module.exports = __webpack_public_path__ + "static/Inbox-mla.b3a0d82b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Inbox-mla.jpg
// module id = 499
// module chunks = 172546399187757